import type { BookingDetails } from 'routes/tourOperator/bookings/types/bookingDetails/bookingDetailsTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type BookingEarthTodayState = {
  value: BookingDetails['earthToday'] | null;
};

const initialState: BookingEarthTodayState = {
  value: null,
};

function setBookingEarthTodayFunction(
  state: BookingEarthTodayState,
  action: PayloadAction<BookingEarthTodayState['value']>
) {
  return {
    ...state,
    value: action.payload,
  };
}

function resetStateFunction() {
  return initialState;
}

const slice = createSlice({
  name: 'bookingDetails.bookingEarthToday',
  initialState,
  reducers: {
    setBookingEarthToday: setBookingEarthTodayFunction,
    resetState: resetStateFunction,
  },
});

export const { setBookingEarthToday, resetState } = slice.actions;
export default slice.reducer;
